import Alpine from "alpinejs";
import "./alpine-editor";
import { EditorController } from "./controller.js";
import { setupStore } from "./store.js";
import { GridSelector } from "./ui/grid_selector";
import { PromptEditor } from "./ui/prompt_editor";
import { AssistantBrainEditor } from "./ui/assistant_brain_editor";

setupStore(Alpine, EditorController);
Alpine.data("GridSelector", GridSelector);
Alpine.data("PromptEditor", PromptEditor);
Alpine.data("AssistantBrainEditor", AssistantBrainEditor);
window.dispatchEvent(new CustomEvent("editor-loaded"));
